import React from 'react';
import { Show, TextField, BooleanField, NumberField, TabbedShowLayout, Tab, ReferenceField } from 'react-admin';

import { DateField } from '../customFields';
import OutputCenterTitle from './OutputCenterTitle';

const OutputCenterShow = (props) => (
	<Show title={<OutputCenterTitle />} {...props}>
		<TabbedShowLayout>
			<Tab label="Details">
				<TextField source="name" />
				<NumberField source="index" />
				<BooleanField source="isCheckout" />
				<BooleanField source="isGo" />
				<ReferenceField source="shopId" reference="shop">
					<TextField source="name" />
				</ReferenceField>
				<BooleanField source="active" />
				<DateField source="createdAt"  />
				<DateField source="updatedAt"  />
				<TextField source="createdBy" />
				<TextField source="updatedBy" />
			</Tab>
		</TabbedShowLayout>
	</Show>
);

export default OutputCenterShow;
